import { Activity } from "../types/activity";
import { aplClient } from "./apiClient";
import axios, { CancelTokenSource } from "axios";

let getActivitiesLablByDepartmentCancelToken: CancelTokenSource | null = null;
const getActivitiesLablByDepartment = (departmentId: number) => {
    getActivitiesLablByDepartmentCancelToken?.cancel();
    getActivitiesLablByDepartmentCancelToken = axios.CancelToken.source();

    return aplClient().get(`activities/bydepartment/${departmentId}/labelling`, {
        cancelToken: getActivitiesLablByDepartmentCancelToken.token
    });
};

let getActivitiesConsByDepartmentCancelToken: CancelTokenSource | null = null;
const getActivitiesConsByDepartment = async (departmentId: number) => {
    getActivitiesConsByDepartmentCancelToken?.cancel();
    getActivitiesConsByDepartmentCancelToken = axios.CancelToken.source();

    return aplClient().get(`activities/bydepartment/${departmentId}/consumption`, {
        cancelToken: getActivitiesConsByDepartmentCancelToken.token
    });
};

const closeConsumption = (lineId: number, operationId: string) => aplClient().delete(`activities/close/consumption/${lineId}/${operationId}`);
const closeLabelling = (lineId: number, operationId: string) => aplClient().delete(`activities/close/labelling/${lineId}/${operationId}`);
const assignLabelling = (lineId: number, operationId: string) => aplClient().put(`activities/assign/labelling/${lineId}/${operationId}`);
const assignConsumption = (lineId: number, operationId: string) => aplClient().put(`activities/assign/consumption/${lineId}/${operationId}`);

let getLineActivityLabellingCancelToken: CancelTokenSource | null = null;
const getLineActivityLabelling = (lineId: number) => {
    getLineActivityLabellingCancelToken?.cancel();
    getLineActivityLabellingCancelToken = axios.CancelToken.source();

    return aplClient().get(`activities/bylineid/${lineId}/labelling`);
};

let getLineActivityConsumptionCancelToken: CancelTokenSource | null = null;
const getLineActivityConsumption = (lineId: number) => {
    getLineActivityConsumptionCancelToken?.cancel();
    getLineActivityConsumptionCancelToken = axios.CancelToken.source();

    return aplClient().get(`activities/bylineid/${lineId}/consumption`, {
        cancelToken: getLineActivityLabellingCancelToken?.token
    });
};

let getWorkorderActivityLabellingCancelToken: CancelTokenSource | null = null;
const getWorkorderActivityLabelling = (operationId: string) => {
    getWorkorderActivityLabellingCancelToken?.cancel();
    getWorkorderActivityLabellingCancelToken = axios.CancelToken.source();

    return aplClient().get(`activities/ByOperationId/${operationId}/labelling`, {
        cancelToken: getWorkorderActivityLabellingCancelToken?.token
    });
};

const getWorkorderActivityConsumption = (operationId: string) => aplClient().get(`activities/ByOperationId/${operationId}/consumption`);

const isPrimaryAlternatingWorkorder = (activity: Activity) => {
    let isSecondaryAlternatingWorkorder = activity.nextSequence % 2 === 0 && activity.alternatingActivity != null;
    return !isSecondaryAlternatingWorkorder;
};

const setUserNumberOfCopiesPerPallet = (operationId: string, value: number) =>
    aplClient().put(`activities/UserNumberOfCopiesPerPallet/${operationId}`, value);

export {
    getActivitiesLablByDepartment,
    getActivitiesConsByDepartment,
    closeConsumption,
    closeLabelling,
    assignLabelling,
    assignConsumption,
    getLineActivityLabelling,
    getLineActivityConsumption,
    getWorkorderActivityLabelling,
    getWorkorderActivityConsumption,
    isPrimaryAlternatingWorkorder,
    setUserNumberOfCopiesPerPallet
};
